/* eslint-disable no-restricted-syntax */
import { environment } from 'src/environments/environment'

export const logger = {
  log: (...args: unknown[]) => {
    if (environment.enableConsoleLog) console.log(...args)
  },
  debug: (...args: unknown[]) => {
    if (environment.enableConsoleLog) console.debug(...args)
  },
  info: (...args: unknown[]) => {
    if (environment.enableConsoleLog) console.info(...args)
  },
}
